'use strict'

module.exports = text

var u = require('unist-builder')

function text(h, node) {
  return h.augment(
    node,
    u('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1'))
  )
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/node_modules/mdast-util-to-hast/lib/handlers/text.js
// module id = aOxS
// module chunks = 0